export const delays = {
 GOLINK: 100,
 GOLINK_ERROR: 2000,
}